const unwrapPersonalAccountSettings = (settings) => (
  Array.isArray(settings) ? settings[0] : settings
)

const sameId = (left, right) => (
  left != null && right != null && String(left) === String(right)
)

export function resolveEffectivePersonalAccountSettings({
  permissions,
  endpointState,
  endpointId,
}) {
  const resolvedEndpointId = endpointId ?? endpointState?.selectedEndpoint?.id
  const permission = permissions?.endpoints?.[resolvedEndpointId]
  const merchantSettings = unwrapPersonalAccountSettings(permission?.personal_account_settings)

  const selectedEndpoint = sameId(endpointState?.selectedEndpoint?.id, resolvedEndpointId)
    ? endpointState.selectedEndpoint
    : null
  const listedEndpoint = endpointState?.endpoints?.data?.find(endpoint => (
    sameId(endpoint?.id, resolvedEndpointId)
  ))
  const selectedEndpointSettings = unwrapPersonalAccountSettings(
    selectedEndpoint?.personal_account_settings
  )
  const listedEndpointSettings = unwrapPersonalAccountSettings(
    listedEndpoint?.personal_account_settings
  )
  const endpointSettings = selectedEndpointSettings ?? listedEndpointSettings

  return {
    ...(merchantSettings || {}),
    ...(endpointSettings || {}),
  }
}

export const selectEffectivePersonalAccountSettings = (state, endpointId) => (
  resolveEffectivePersonalAccountSettings({
    permissions: state?.user?.permissions,
    endpointState: state?.endpoint,
    endpointId,
  })
)

export const selectIsSempCabinet = (state, endpointId) => (
  selectEffectivePersonalAccountSettings(state, endpointId)?.is_semp_cabinet === true
)
